<template>
  <div class="hidden lg:flex lg:flex-shrink-0 relative">
    <transition v-if="isOpenNav"
        enter-class="transition ease-linear duration-300"
        enter-active-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="transition ease-linear duration-300"
        leave-active-class="opacity-100"
        leave-to-class="opacity-0"
    >

    <div class="flex flex-col border-r border-gray-200 pt-5 pb-4 bg-gray-100 " :class="[{'w-64 block': isOpenNav}, {'w-0 hidden': !isOpenNav}]">

      <div class="flex items-center flex-shrink-0 px-6 relative">
        <svg class="h-15 w-full mx-auto" version="1.1" id="Layer_1" xmlns:x="&ns_extend;" xmlns:i="&ns_ai;" xmlns:graph="&ns_graphs;"
             xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 648 197"
             style="enable-background:new 0 0 648 197;" xml:space="preserve">

          <switch>

            <g i:extraneous="self">
                        <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="0" y1="338.5" x2="0.7071" y2="337.7929">
                            <stop  offset="0" style="stop-color:#20AC4B"/>
                          <stop  offset="0.9831" style="stop-color:#19361A"/>
                        </linearGradient>
              <circle class="st0" cx="381.26" cy="79.91" r="58"/>
              <g>
                            <path class="st1" d="M376.8,98.15c-1.59-3.33-5.29-3.53-11.07-6.29c-7.24-3.44-5.64-21.44-3.84-35.94
                            c1.79-14.51-0.45-15.19-1.27-19.3c-0.55-2.73,0.63-7.38,2.77-11.9c-23.28,7.53-40.13,29.39-40.13,55.18
                            c0,30.07,22.88,54.79,52.18,57.71C373.7,124.58,378.61,101.93,376.8,98.15z"/>
                <path class="st1" d="M415.39,92.71c-10.57-2.29-3.52-40.31-3.52-40.31s0.76-5.46,1.37-8.7c0.54-2.83-2.73-9.56-0.93-12.78
                            c-8.98-5.7-19.62-9.02-31.04-9.02c-3.44,0-6.8,0.31-10.08,0.89c0.41,1.76,0.44,4.06-0.17,6.96c-0.6,5.83,1.12,5.83,0.9,7.93
                            c-0.22,2.09-0.82,10.17-0.82,10.17s1.72,26.28,2.66,28.32c0.95,2.04,6.63-0.4,13.77,0.75l13.06,8.88l6.34-4.57
                            c0.52,5.98,2.08,10.73,5.6,11.49c3.15,0.68,5.98,0.95,8.42,0.8C419.22,93.41,417.36,93.14,415.39,92.71z M406.7,76.38l-6.52,4.57
                            c0,0-5.28-3.19-7.97-4.49c2.49-0.3,2.59,0.5,3.19-1.9c0.6-2.39-3.59-1.49-4.58-4.28c-0.99-2.79-0.5-20.24-0.5-20.24
                            s-0.93-11,14.36-10.17c2.33,0.13,4.16,0.65,5.59,1.43c0.16,0.94,0.24,1.78,0.11,2.41c-0.62,3.24-1.37,8.7-1.37,8.7
                            S406.63,65.19,406.7,76.38z"/>
                <path class="st1" d="M439.27,79.91c0-15.27-5.91-29.16-15.56-39.52c-2.93,4.2-2.47,7.48-2.09,11.39
                            c1.19,5.28,2.69,24.83,2.19,28.62c1-1,0.89-4.19,0.5-5.58c4.09-0.9,9.17,2.29,8.97,10.07c-0.05,1.91-0.51,3.49-1.32,4.76
                            l0.03,0.03c0,0-2.55,12.37-4.32,25.03C434.95,105.01,439.27,92.97,439.27,79.91z"/>
                <g>
                                <path class="st1" d="M24.13,109.92c6.79,3.33,17.22,6.66,27.98,6.66c11.59,0,17.72-4.6,17.72-11.57
                                c0-6.66-5.3-10.46-18.71-15.06c-18.55-6.18-30.63-16.01-30.63-31.54c0-18.22,15.89-32.17,42.22-32.17
                                c12.58,0,21.85,2.54,28.48,5.39l-5.63,19.49c-4.47-2.06-12.42-5.07-23.34-5.07c-10.93,0-16.23,4.75-16.23,10.29
                                c0,6.82,6.29,9.83,20.69,15.06c19.71,6.97,28.98,16.8,28.98,31.86c0,17.91-14.4,33.28-45.04,33.28
                                c-12.75,0-25.33-3.33-31.62-6.66L24.13,109.92z"/>
                  <path class="st1" d="M129.76,27.99v106.81h-25.33V27.99H129.76z"/>
                  <path class="st1" d="M143.33,29.42c9.27-1.43,21.36-2.22,34.11-2.22c21.19,0,34.94,3.64,45.69,11.41
                                C234.71,46.86,242,60.01,242,78.86c0,20.45-7.78,34.55-18.54,43.27c-11.76,9.35-29.64,13.79-51.49,13.79
                                c-13.08,0-22.35-0.79-28.64-1.59V29.42z M168.66,116.58c2.15,0.48,5.63,0.48,8.78,0.48c22.85,0.16,37.75-11.89,37.75-37.4
                                c0.16-22.19-13.41-33.91-35.1-33.91c-5.62,0-9.27,0.47-11.42,0.95V116.58z"/>
                  <path class="st1" d="M316.67,89.64h-41.06V115h45.86v19.81h-71.19V27.99h68.87V47.8h-43.54v22.19h41.06V89.64z"/>
                            </g>
                <g>
                                <radialGradient id="SVGID_2_" cx="278.243" cy="45.9032" r="435.4667" gradientUnits="userSpaceOnUse">
                                    <stop  offset="0" style="stop-color:#000000"/>
                                  <stop  offset="1" style="stop-color:#010101"/>
                                </radialGradient>
                  <path class="st2" d="M34.48,144.37h22.14v5.61H42.71v6.9h13.01v5.56H42.71v12.15h-8.22V144.37z"/>
                  <radialGradient id="SVGID_3_" cx="278.2891" cy="45.8548" r="435.583" gradientUnits="userSpaceOnUse">
                                    <stop  offset="0" style="stop-color:#000000"/>
                    <stop  offset="1" style="stop-color:#010101"/>
                                </radialGradient>
                  <path class="st3" d="M122.85,159.17c0,9.92-7.2,15.92-17.79,15.92c-10.75,0-17.04-6.77-17.04-15.39
                                c0-9.06,6.94-15.84,17.63-15.84C116.77,143.87,122.85,150.83,122.85,159.17z M96.66,159.57c0,5.92,3.33,10.09,8.82,10.09
                                c5.53,0,8.71-4.4,8.71-10.27c0-5.43-3.12-10.1-8.77-10.1C99.9,149.3,96.66,153.7,96.66,159.57z"/>
                  <radialGradient id="SVGID_4_" cx="278.2659" cy="45.8886" r="435.4849" gradientUnits="userSpaceOnUse">
                                    <stop  offset="0" style="stop-color:#000000"/>
                    <stop  offset="1" style="stop-color:#010101"/>
                                </radialGradient>
                  <path class="st4" d="M163.27,144.37v17.4c0,5.21,2.36,7.85,6.55,7.85c4.3,0,6.67-2.51,6.67-7.85v-17.4h8.17v16.96
                                c0,9.33-5.64,13.77-15.11,13.77c-9.13,0-14.51-4.22-14.51-13.86v-16.87H163.27z"/>
                  <radialGradient id="SVGID_5_" cx="278.2792" cy="45.9032" r="435.4246" gradientUnits="userSpaceOnUse">
                                    <stop  offset="0" style="stop-color:#000000"/>
                    <stop  offset="1" style="stop-color:#010101"/>
                                </radialGradient>
                  <path class="st5" d="M218.62,174.6v-30.23h9.57l7.52,11.08c2.15,3.18,4.3,6.95,5.91,10.35h0.17c-0.54-3.99-0.7-8.07-0.7-12.65
                                v-8.79h7.52v30.23h-8.6l-7.74-11.66c-2.15-3.23-4.52-7.13-6.29-10.67l-0.16,0.05c0.21,3.99,0.32,8.25,0.32,13.18v9.11H218.62z"
                  />
                  <radialGradient id="SVGID_6_" cx="278.2845" cy="45.8768" r="435.5246" gradientUnits="userSpaceOnUse">
                                    <stop  offset="0" style="stop-color:#000000"/>
                    <stop  offset="1" style="stop-color:#010101"/>
                                </radialGradient>
                  <path class="st6" d="M282.59,144.77c3-0.4,6.93-0.62,11.07-0.62c6.88,0,11.34,1.03,14.84,3.22c3.76,2.34,6.12,6.05,6.12,11.39
                                c0,5.8-2.53,9.78-6.03,12.25c-3.81,2.65-9.62,3.9-16.71,3.9c-4.25,0-7.26-0.23-9.3-0.45V144.77z M290.81,169.44
                                c0.7,0.13,1.82,0.13,2.85,0.13c7.41,0.04,12.25-3.36,12.25-10.58c0.06-6.28-4.36-9.61-11.4-9.61c-1.83,0-3.01,0.14-3.7,0.27
                                V169.44z"/>
                  <radialGradient id="SVGID_7_" cx="278.2774" cy="45.9032" r="435.4821" gradientUnits="userSpaceOnUse">
                                    <stop  offset="0" style="stop-color:#000000"/>
                    <stop  offset="1" style="stop-color:#010101"/>
                                </radialGradient>
                  <path class="st7" d="M354.44,166.84l-2.58,7.76h-8.49l11.07-30.23h10.75l11.24,30.23h-8.82l-2.8-7.76H354.44z M363.64,161.73
                                l-2.26-6.41c-0.64-1.79-1.29-4.04-1.83-5.83h-0.11c-0.53,1.79-1.07,4.08-1.66,5.83l-2.15,6.41H363.64z"/>
                  <radialGradient id="SVGID_8_" cx="278.3047" cy="45.9032" r="435.4522" gradientUnits="userSpaceOnUse">
                                    <stop  offset="0" style="stop-color:#000000"/>
                    <stop  offset="1" style="stop-color:#010101"/>
                                </radialGradient>
                  <path class="st8" d="M410.66,150.11h-9.73v-5.74h27.84v5.74h-9.89v24.49h-8.23V150.11z"/>
                  <radialGradient id="SVGID_9_" cx="278.2507" cy="45.9032" r="435.5579" gradientUnits="userSpaceOnUse">
                                    <stop  offset="0" style="stop-color:#000000"/>
                    <stop  offset="1" style="stop-color:#010101"/>
                                </radialGradient>
                  <path class="st9" d="M468.23,144.37v30.23H460v-30.23H468.23z"/>
                  <radialGradient id="SVGID_10_" cx="278.331" cy="45.8548" r="435.4947" gradientUnits="userSpaceOnUse">
                                    <stop  offset="0" style="stop-color:#000000"/>
                    <stop  offset="1" style="stop-color:#010101"/>
                                </radialGradient>
                  <path class="st10" d="M535.36,159.17c0,9.92-7.2,15.92-17.79,15.92c-10.74,0-17.03-6.77-17.03-15.39
                                c0-9.06,6.93-15.84,17.63-15.84C529.29,143.87,535.36,150.83,535.36,159.17z M509.18,159.57c0,5.92,3.33,10.09,8.81,10.09
                                c5.54,0,8.71-4.4,8.71-10.27c0-5.43-3.12-10.1-8.76-10.1C512.41,149.3,509.18,153.7,509.18,159.57z"/>
                  <radialGradient id="SVGID_11_" cx="278.2992" cy="45.9032" r="435.5134" gradientUnits="userSpaceOnUse">
                                    <stop  offset="0" style="stop-color:#000000"/>
                    <stop  offset="1" style="stop-color:#010101"/>
                                </radialGradient>
                  <path class="st11" d="M567.61,174.6v-30.23h9.57l7.52,11.08c2.15,3.18,4.3,6.95,5.92,10.35h0.16c-0.54-3.99-0.7-8.07-0.7-12.65
                                v-8.79h7.53v30.23H589l-7.74-11.66c-2.15-3.23-4.51-7.13-6.28-10.67l-0.17,0.05c0.21,3.99,0.33,8.25,0.33,13.18v9.11H567.61z"/>
                            </g>
                <g>
                                <path class="st1" d="M471.18,27.9v61.9c0,18.5,7.34,27.91,20.34,27.91c13.33,0,20.66-8.93,20.66-27.91V27.9h25.33v60.3
                                c0,33.18-17.5,48.97-46.83,48.97c-28.33,0-44.99-14.99-44.99-49.29V27.9H471.18z"/>
                  <path class="st1" d="M572.84,48.32h-30.17V27.9H629v20.42h-30.66v87.09h-25.49V48.32z"/>
                            </g>
                        </g>
                    </g>
                </switch>
        </svg>

      </div>
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div class="h-0 flex-1 flex flex-col overflow-y-auto">
        <!-- User account dropdown -->
        <div class="px-3 mt-6 relative inline-block text-left">
          <div>
            <!-- Dropdown menu toggle, controlling the show/hide state of dropdown menu. -->
            <div>
              <button @click="isOpen = !isOpen" v-click-outside="setOpenToFalse" type="button" class="group w-full bg-gray-100 px-3.5 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:outline-none  focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-purple-500" id="options-menu" aria-haspopup="true" aria-expanded="true">
                    <span class="flex w-full justify-between items-center">
                        <span class="flex min-w-0 items-center justify-between space-x-3">
                          <img class="w-10 h-10 bg-gray-300 rounded-full flex-shrink-0" :src="user.gravatar" alt="">
<!--                          <img class="w-10 h-10 bg-gray-300 rounded-full flex-shrink-0" src="https://images.unsplash.com/photo-1502685104226-ee32379fefbe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=256&h=256&q=80" alt="">-->
                        <span class="flex-1 min-w-0">
                             <p class="text-gray-900 text-sm font-medium truncate">{{user.name}}</p>
                            <p class="text-gray-500 text-sm truncate">@{{user.name}}</p>
                        </span>
                        </span>
                      <!-- Heroicon name: selector -->
                        <svg class="flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>
                    </span>
              </button>
            </div>

            <transition
                name="custom-classes-transition"
                enter-class="transition ease-out duration-100 transform"
                enter-active-class="opacity-0 scale-95"
                enter-to-class="opacity-100 scale-100"
                leave-class="transition ease-in duration-75 transform"
                leave-active-class="opacity-100 scale-100"
                leave-to-class="opacity-0 scale-95"
            >
              <div v-if="isOpen"
                              class="z-10 mx-3 origin-top absolute right-0 left-0 mt-1 shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200" role="menu" aria-orientation="vertical" aria-labelledby="options-menu"
              >
                <div class="py-1">
                  <a href="/profile" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">Profile Settings</a>
                </div>
                <div class="py-1">
                  <a href="#" @click="logout"
                     class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">Logout</a>
                </div>
              </div>
            </transition>


          </div>
        </div>

        <nav class="px-3 mt-6">
          <navigation :user="user"/>
        </nav>
      </div>
    </div>


    </transition>
  </div>
</template>

<script>
  import Navigation from "./Navigation";

  export default {
    name: 'DesktopSideBar',
    components: {Navigation},
    props: {
      user: {}
    },
    data() {
      return {
        isOpen: false,
        isOpenNav: true,
      }
    },
    methods: {
      setOpenToFalse() {
        this.isOpen = false;
      },
      logout() {
        let token = document.head.querySelector('meta[name="csrf-token"]');
        axios.post('/logout', {_token: token.content})
            .then(response => {
              window.location.href = '/login'
            })
      },
    },
    computed: {
      token() {
        return $('meta[name="csrf-token"]').attr('content')
      },
    },
  }
</script>

<style scoped>
  .Arched_x0020_Green{fill:url(#SVGID_1_);stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:1;}
  .st0{fill:#FFFFFF;}
  .st1{fill:#E50695;}
  .st2{fill:url(#SVGID_2_);}
  .st3{fill:url(#SVGID_3_);}
  .st4{fill:url(#SVGID_4_);}
  .st5{fill:url(#SVGID_5_);}
  .st6{fill:url(#SVGID_6_);}
  .st7{fill:url(#SVGID_7_);}
  .st8{fill:url(#SVGID_8_);}
  .st9{fill:url(#SVGID_9_);}
  .st10{fill:url(#SVGID_10_);}
  .st11{fill:url(#SVGID_11_);}
</style>
